# TODO: Should be mutation
query tempMediaPresignedUrl($fileName: String!, $contentType: String!) {
  tempMediaPresignedUrl(fileName: $fileName, contentType: $contentType) {
    key
    url
  }
}
